export default __webpack_public_path__ + "bf37cf7b1bc2a1700cc259b8a64f6f95.glb";